import { Coding } from 'fhir/r4b';

export const FULL_PHOTO_ID_CARD_TITLE = 'fullPhotoIDCard';
export const FULL_INSURANCE_CARD_TITLE = 'fullInsuranceCard';
export const FULL_INSURANCE_CARD_2_TITLE = 'fullInsuranceCard-2';
export const INSURANCE_CARD_FRONT_ID = 'insurance-card-front';
export const INSURANCE_CARD_BACK_ID = 'insurance-card-back';
export const INSURANCE_CARD_FRONT_2_ID = 'insurance-card-front-2';
export const INSURANCE_CARD_BACK_2_ID = 'insurance-card-back-2';
export const PATIENT_PHOTO_ID_PREFIX = 'patient-photo';
export const PATIENT_PHOTOS_MAX_COUNT_TELEMED = 4;
export const PHOTO_ID_FRONT_ID = 'photo-id-front';
export const PHOTO_ID_BACK_ID = 'photo-id-back';
export const SCHOOL_WORK_NOTE = 'school-work-note';
export const SCHOOL_WORK_NOTE_SCHOOL_ID = 'school-work-note-template-school';
export const SCHOOL_WORK_NOTE_WORK_ID = 'school-work-note-template-work';

export const INSURANCE_CARD_CODE = '64290-0';
export const PATIENT_PHOTO_CODE = '72170-4';
export const PHOTO_ID_CARD_CODE = '55188-7';
export const SCHOOL_WORK_NOTE_CODE = '47420-5';
export const RECEIPT_CODE = '34105-7';
export const EXPORTED_QUESTIONNAIRE_CODE = '74465-6';
export const SCHOOL_WORK_NOTE_TEMPLATE_CODE = 'school-work-note-template';

export const PAPERWORK_CONSENT_CODING_LOINC: Coding = {
  system: 'http://loinc.org',
  code: '59284-0',
  display: 'Consent Documents',
};

export const PAPERWORK_CONSENT_CODE_UNIQUE: Coding = {
  system: 'https://fhir.ottehr.com/CodeSystem/consent-source',
  code: 'patient-registration',
  display: 'Patient Registration Consent',
};
export const PRIVACY_POLICY_CODE = '64292-6';
export const VISIT_NOTE_SUMMARY_CODE = '75498-6';
export const VISIT_DETAILS_CODE = 'visit-details';
export const DISCHARGE_SUMMARY_CODE = 'discharge-summary';
export const MEDICAL_RECORD_EXPORT_CODE = 'medical-record-export';
export const PATIENT_EDUCATION_DOC_TYPE_CODE = 'patient-education';
export const PATIENT_EDUCATION_APPROVED_DOC_TYPE_CODE = 'patient-education-approved';
export const PATIENT_EDUCATION_APPROVED_LIST_IDENTIFIER = {
  system: 'https://fhir.ottehr.com/Identifier/patient-education-approved-list',
  value: 'index',
};

export const PATIENT_EDUCATION_APPROVED_ICD_EXTENSION_URL =
  'https://fhir.ottehr.com/Extension/patient-education-approved-icd-codes';

export const STATEMENT_CODE = 'statement-code';
export const RADIOLOGY_REPORT_CODE = '18748-4';

export const FAX_PACKET_CODE = 'fax-packet';

export const ComplexValidationType = {
  insuranceEligibility: 'insurance eligibility',
};

export const PAPERWORK_PDF_BASE_NAME = 'paperwork';
